// 预置色
export const color = ['#38A2FB', '#C7000B', '#0E458B', '#FD6F5C', '#FF8B0A', '#06D47D']
// 跳转(区分打开方式)
export const goAppId = {
  1: 'pageId',
  2: 'pageId',
  3: 'pageId',
  4: 'pageId',
  5: 'pageId',
  6: 'dataId',
  7: 'dataId',
  8: 'funId',
  9: 'funId',
  10: 'funId',
  11: 'addId',
  12: 'addId',
  13: 'pageId',
  14: 'dataId',
  15: 'pageId',
  16: 'dataId',
  17: 'pageId',
  18: 'dataId'
}
